import { createSelector } from 'reselect'
import { OfficialRatesData } from './statusbar.types'

const defaultArr = []
const defaultObj = {}

const getCommercialRates = (_, { commercialRates }) => commercialRates || defaultArr
const getOfficialRates = (_, { officialRates }) => officialRates || defaultArr
const getForeignCCY = (_, { foreignCCY }) => foreignCCY
const getForeignCCY2 = (_, { foreignCCY2 }) => foreignCCY2
const getLocalCCY = (_, { localCCY }) => localCCY

export const getOfficialRate = createSelector(
  getOfficialRates,
  getForeignCCY,
  (rates = defaultArr, foreignCCY) => rates.find((rate: OfficialRatesData) => rate.CCY === foreignCCY) || defaultObj,
)

export const getOfficialRate2 = createSelector(
  getOfficialRates,
  getForeignCCY2,
  (rates = defaultArr, foreignCCY2) => rates.find((rate: OfficialRatesData) => rate.CCY === foreignCCY2) || defaultObj,
)

export const getCommercialRate = createSelector(
  getCommercialRates,
  getLocalCCY,
  getForeignCCY,
  (rates = defaultArr, localCCY, foreignCCY) =>
    rates.find((rate) => rate.CCY === localCCY && rate.CCY2 === foreignCCY) || defaultObj,
)

export const getCommercialRate2 = createSelector(
  getCommercialRates,
  getLocalCCY,
  getForeignCCY2,
  (rates = defaultArr, localCCY, foreignCCY2) =>
    rates.find((rate) => rate.CCY === localCCY && rate.CCY2 === foreignCCY2) || defaultObj,
)

// DEPRACATED ?
export function getCurrencyRates(_, { officialRates }) {
  return officialRates.reduce((accumulation, cur) => {
    accumulation[cur.CCY] = cur // eslint-disable-line
    return accumulation
  }, {})
}
